import React, { useState } from "react";
import { InlineOptionSelect } from "./InlineOptionSelect";
import { StoryNode } from "../StoryBook/StoryData";

export const InlineOptionSelectStories = [
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <InlineOptionSelect
                    text={val}
                    options={["a", "b"]}
                    onEdit={(newVal: string) => {
                        setVal(newVal);
                        logCallback(newVal);
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Inline Option Select"
    ),
];
